import * as Yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
import { ACCOUNT_TYPES } from 'utils/constants'
import { locationsSchema } from './location'
import { vehiclesSchema } from './vehicle'
import { contactsSchema, contactsSchemaForSupplier } from './contact'

const fieldRequiredMsg = 'This field is required'

const validationSchema = {
  accountType: Yup.string().nullable().required(fieldRequiredMsg),
  companyName: Yup.string().nullable().required(fieldRequiredMsg),
  supplierTypeId: Yup.string()
    .nullable()
    .when('accountType', {
      is: !ACCOUNT_TYPES.CARRIER.id,
      then: Yup.string().nullable().required(fieldRequiredMsg),
    }),
  vendorClassId: Yup.string().nullable(),
  notes: Yup.string().nullable(),
  priceSheetId: Yup.string().nullable(),
  status: Yup.string().nullable(),
  locations: locationsSchema.locationsArray,
  contacts: contactsSchema.contactsArray,
  vehicles: vehiclesSchema.vehiclesArray,
}

export const getFormOptions = isSupplier => {
  const schema = Yup.object().shape({
    ...validationSchema,
    ...(isSupplier && {
      companyName: Yup.string().nullable(),
      contacts: contactsSchemaForSupplier.contactsArray,
    }),
  })
  return yupResolver(schema)
}

export default Yup.object().shape(validationSchema)
